module.exports={CREDITS:"Créditos",CREDITS_CONTENT:"Este sitio web utiliza librerías y gráficos que están licenciados.",GRAPHICS_TITLE:"Gráficos e imágenes"};